import {
    DIC
} from '@/const/dic'
import {
    formatterTime
} from '@/util/util'
import {
    baseUrl
} from '@/config/env';




export const productOrderDetailsMerchantOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '160',
    //menuType:'menu',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "订单编号",
            prop: "orderNumber",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "销售渠道",
            prop: "orderType",
            type: "select",
            search: true,
            dicData: DIC.PRODUCT_ORDER_TYPE,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '商品数量',
            prop: 'goodsCount',
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '订单金额',
            prop: 'orderAmount',
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '销售金额',
            prop: 'saleAmount',
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '商品折扣',
            prop: 'discountAmount',
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '优惠券名称',
            prop: 'couponName',
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '优惠券金额',
            prop: 'couponAmount',
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '推广佣金',
            prop: 'promoteAmount',
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '平台抽成',
            prop: 'platformAmount',
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '订单状态',
            prop: 'status',
            solt: true,
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '下单人类型',
            prop: 'clientType',
            solt: true,
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '下单人姓名',
            prop: 'realName',
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '下单人电话',
            prop: 'orderMobile',
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '推广人客户端类型',
            prop: 'promoteClientType',
            addVisdiplay: false,
            editVisdiplay: false,
            solt: true
        }, {
            label: '推广人名称',
            prop: 'promoteName',
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '推广人帐号',
            prop: 'promoteAccount',
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '商品推广人名称',
            prop: 'goodsPromoteName',
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '商品推广人账号',
            prop: 'goodsPromoteAccount',
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '商品推广金额',
            prop: 'goodsPromoteAmount',
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: "下单时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: "支付时间",
            prop: "payTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "支付时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            search: true,
            hide: true,
            clearable: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        },
        {
            label: '收货人姓名',
            prop: 'name',
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '收货人电话',
            prop: 'mobile',
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '收货地址',
            prop: 'address',
            solt: true,
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '配送方',
            prop: 'deliveryMan',
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '配送费',
            prop: 'deliveryAmount',
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: "配送时间",
            prop: "deliveryTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: '配送经销商',
            prop: 'deliveryId',
            formsolt: true,
            hide: true,
        }
        // ,{
        //     label: '配送费用比例',
        //     prop: 'amount',
        //     hide: true,
        //
        // }

    ]
};